import { routeInfo } from './../../../../routeInfo';
import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/user/actions.user';
import history from '../../../../history';
import isValidEmail from '../../../../services/mini/isValidEmail';
import ValidationForm from '../../../forms/ValidationForm';
import LoginBackButton from '../LoginBackButton/LoginBackButton';

class RequestNewPasswordForm extends React.Component {
    goBack = () => {
        history.push(routeInfo.login.url());
    }

    validateEmail = ({ email }) => {
        if (!isValidEmail(email)) {
            return 'Enter valid email address';
        }
        if (!email) {
            return 'Enter an email address';
        }
        return null;
    }

    ok = ({ email }) => {
        const { requestRestorePasswordEmail } = this.props;
        requestRestorePasswordEmail({ email });
    }

    render() {
        const { email } = this.props;
        return (
            <div className="request-new-password-form">
                <div className="request-new-password-form_header">
                    <LoginBackButton goBack={this.goBack} />
                    Forgot your password
                </div>
                <div className="request-new-password-form_msg">
                    Enter your email address and we will send a link to restore it.
                </div>
                <ValidationForm
                    enableActionBtnAlways={true}
                    inputs={[
                        {
                            label: "Email",
                            name: "email",
                            value: email,
                            applyOnEnter: true,
                            rules: [this.validateEmail]
                        }
                    ]}
                    buttons={[{
                        key: 'ok',
                        label: 'Restore Password',
                        action: this.ok,
                        className: 'sign-in-form_btn request-new-password-form_btn'
                    }]} />
            </div>
        );
    }
}


function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        requestRestorePasswordEmail: (param) => dispatch(actions.requestRestorePasswordEmail(param))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestNewPasswordForm);

